import { Component, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {evaluatorRoleProgram, Session} from "../../services/session.service";
import {RoutesEnum} from "../../enums/routes.enum";
import {GenericService} from "../../services/generic.service";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private session: Session,
    private genericService: GenericService,
  ) {
    const logoutUrl = this.genericService.getParam('source', this.route);

    if(logoutUrl){
      this.session.setLogoutUrl(logoutUrl);
    }
    if(this.session.isActingAsCommissioner()) {
      this.router.navigate(['/commissioner']);
      return;
    }
    if(this.session.isEvaluatorWithNoPrograms()) {
      this.router.navigate(['/dashboard/reviewer']);
      return;
    }
    if(this.session.isEvaluatorWorkingForOtherInstitution()){ // We keep this for now
      const evaluatorProgram: evaluatorRoleProgram = this.session.getEvaluatorProgram();
      if(evaluatorProgram){
        if(evaluatorProgram.programDirectoryProgramRequestKey){
          this.router.navigate([
            '/directory/program', evaluatorProgram.programDirectoryRequestKey, evaluatorProgram.programDirectoryProgramRequestKey
          ]);
        }
        else if(evaluatorProgram.institutionDirectoryRequestKey){
          this.router.navigate([
            '/directory/institutions', evaluatorProgram.institutionDirectoryRequestKey
          ]);
        }
        else if(evaluatorProgram.requestKey) {
          this.router.navigate(['/accreditation/workspace', RoutesEnum.Accreditor, evaluatorProgram.requestKey]);
        }
      }
      else{
        //No program found, we need the user to login again
        this.session.logout();
      }
      return;
    }
    if (this.session.isNewApplicant()){ // We keep this for applicant users
      this.router.navigate(['/dashboard/new-application']);
    }
    else {
      //if the user has an account, go to dashboard, else go to no-account
      const currentAccount = this.session.getCurrentAccount();
      if(currentAccount?.accountRequestKey) {
        this.router.navigate(['/dashboard']);
      } else {
        this.router.navigate(['/no-account']);
      }
    }
  }
}
